export enum ZincCoating {
	None = 0,
	HotDip = 1,
	Galvanize = 2,
	Both = 3, // Only exists in frontend
}

export const getZincCoatingText = (zincCoating: ZincCoating): string => {
	const coatingMap: Record<ZincCoating, string> = {
		[ZincCoating.None]: "Nein",
		[ZincCoating.HotDip]: "Feuerverzinkt",
		[ZincCoating.Galvanize]: "Galvanisch Verzinkt",
		[ZincCoating.Both]: "Beide",
	};

	return coatingMap[zincCoating] ?? "n/a";
};
